// assets
import { IconDashboard, IconUser, IconCategory,IconCategory2,IconVideo, IconPhoto, IconDeviceTvOld, IconClipboardList, IconSettings, IconCalendar } from '@tabler/icons';

// constant
const icons = {
    IconDashboard: IconDashboard,
    IconUser: IconUser,
    IconCategory: IconCategory,
    IconCategory2:IconCategory2,
    IconVideo: IconVideo,
    IconPhoto: IconPhoto,
    IconDeviceTvOld: IconDeviceTvOld,
    IconClipboardList: IconClipboardList,
    IconSettings: IconSettings,
    IconCalendar: IconCalendar,
};

//-----------------------|| DASHBOARD MENU ITEMS ||-----------------------//

export const dashboard = {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'default',
            title: 'Dashboard',
            type: 'item',
            url: '/dashboard/default',
            icon: icons['IconDashboard'],
            breadcrumbs: false,
            roles: ['admin', 'sub-admin', 'moderator'],
        },
        {
            id: 'user-list',
            title: 'Users',
            type: 'item',
            url: '/user-list',
            icon: icons['IconUser'],
            breadcrumbs: false,
            roles: ['admin', 'sub-admin'],
        },
        {
            id: 'project-list',
            title: 'Projects',
            type: 'item',
            url: '/project-list',
            icon: icons['IconClipboardList'],
            breadcrumbs: false,
            roles: ['admin', 'supervisor', 'sub-admin', 'moderator'],
        },
        {
            id: 'calendar',
            title: 'Calendar',
            type: 'item',
            url: '/calendar',
            icon: icons['IconCalendar'],
            breadcrumbs: false,
            roles: ['admin', 'sub-admin', 'moderator'],
        },

        // {
        //     id: 'banner-list',
        //     title: 'Banner',
        //     type: 'item',
        //     url: '/banner-list',
        //     icon: icons['IconPhoto'],
        //     breadcrumbs: false,
        //     roles: ['admin'],
        // },

        // {
        //     id: 'category-list',
        //     title: 'Category',
        //     type: 'item',
        //     url: '/category-list',
        //     icon: icons['IconCategory'],
        //     breadcrumbs: false,
        //     roles: ['admin'],
        // },
        // {
        //     id: 'sub-category-list',
        //     title: 'Sub-Category',
        //     type: 'item',
        //     url: '/sub-category-list',
        //     icon: icons['IconCategory2'],
        //     breadcrumbs: false,
        //     roles: ['admin'],
        // },
        // {
        //     id: 'group-list',
        //     title: 'Group',
        //     type: 'item',
        //     url: '/group-list',
        //     icon: icons['IconCategory2'],
        //     breadcrumbs: false,
        //     roles: ['admin'],
        // },

        // {
        //     id: 'channel-list',
        //     title: 'Channel',
        //     type: 'item',
        //     url: '/channel-list',
        //     icon: icons['IconDeviceTvOld'],
        //     breadcrumbs: false,
        //     roles: ['admin'],
        // },

    ]
};
